var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useEffect, useRef, useMemo, useCallback } from 'react';
import { useWatch } from 'react-hook-form';
import moment from 'moment';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
import { conflictsWithExistingEvent, isAbortError } from '../../../utils/utils';
export var useSpaceConflictDetection = function (_a) {
    var spaceId = _a.spaceId, spaceBuffers = _a.spaceBuffers, apiUrl = _a.apiUrl, accessToken = _a.accessToken, getEventsBySpaceId = _a.getEventsBySpaceId, onError = _a.onError;
    var debounceRef = useRef(null);
    var inFlightKeyRef = useRef(undefined);
    var latestConflictKeyRef = useRef('');
    var conflictAbortControllerRef = useRef(null);
    var previousCheckKeyRef = useRef();
    var _b = useEventComposerGlobalContext(), updateSpaceConflicts = _b.updateSpaceConflicts, incrementConflictChecks = _b.incrementConflictChecks, decrementConflictChecks = _b.decrementConflictChecks;
    var _c = __read(useWatch({
        name: ['startTime', 'endTime', 'eventId', 'uid'],
    }), 4), startTime = _c[0], endTime = _c[1], eventId = _c[2], uid = _c[3];
    /* We ignore the current event ID and buffer IDs when checking for conflicts.
     * Both eventId and uid are included because the form's eventId comes from the
     * v2.0 API while getEventsBySpaceId returns events from the v1 API — their id
     * formats differ, but uid (iCalendar UID) is consistent across both. */
    var idsToIgnore = useMemo(function () {
        var ids = [];
        if (eventId) {
            ids.push(eventId);
        }
        if (uid) {
            ids.push(uid);
        }
        if (spaceBuffers === null || spaceBuffers === void 0 ? void 0 : spaceBuffers[spaceId]) {
            var buffer = spaceBuffers[spaceId];
            if (buffer.bufferBeforeId) {
                ids.push(buffer.bufferBeforeId.toString());
            }
            if (buffer.bufferAfterId) {
                ids.push(buffer.bufferAfterId.toString());
            }
        }
        return ids;
    }, [eventId, uid, spaceBuffers, spaceId]);
    var checkSpaceHasConflict = useCallback(function (spaceId, startTime, endTime, signal) { return __awaiter(void 0, void 0, void 0, function () {
        var start, end, events, eventsToCheck, conflicts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    start = startTime.clone();
                    end = endTime.clone();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getEventsBySpaceId(spaceId, start.format(), end.format(), apiUrl, accessToken, signal)];
                case 2:
                    events = _a.sent();
                    if (!events.length) {
                        return [2 /*return*/, []];
                    }
                    eventsToCheck = events.filter(function (event) {
                        return !idsToIgnore.includes(event.id) && !idsToIgnore.includes(event.uid);
                    });
                    if (!eventsToCheck.length) {
                        return [2 /*return*/, []];
                    }
                    conflicts = conflictsWithExistingEvent({
                        startTime: start.format(),
                        endTime: end.format(),
                        ids: idsToIgnore,
                    }, eventsToCheck.map(function (event) { return ({
                        startTime: event.start.date_time,
                        endTime: event.end.date_time,
                        id: event.id,
                    }); }));
                    return [2 /*return*/, conflicts];
                case 3:
                    error_1 = _a.sent();
                    if (isAbortError(error_1)) {
                        throw error_1;
                    }
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [apiUrl, accessToken, idsToIgnore, getEventsBySpaceId]);
    // Calculate total time range including buffers
    var totalTimeRange = useMemo(function () {
        if (!startTime || !endTime)
            return null;
        var buffer = spaceBuffers === null || spaceBuffers === void 0 ? void 0 : spaceBuffers[spaceId];
        var totalStart = startTime.clone();
        var totalEnd = endTime.clone();
        if (buffer === null || buffer === void 0 ? void 0 : buffer.beforeEvent) {
            totalStart = startTime
                .clone()
                .subtract(moment.duration(buffer.beforeEvent));
        }
        if (buffer === null || buffer === void 0 ? void 0 : buffer.afterEvent) {
            totalEnd = endTime.clone().add(moment.duration(buffer.afterEvent));
        }
        return { totalStart: totalStart, totalEnd: totalEnd, eventStart: startTime, eventEnd: endTime };
    }, [startTime, endTime, spaceId, spaceBuffers]);
    // Create a stable key to track when we actually need to check conflicts
    var conflictCheckKey = useMemo(function () {
        if (!totalTimeRange)
            return '';
        return [
            totalTimeRange.totalStart.toISOString(),
            totalTimeRange.totalEnd.toISOString(),
            totalTimeRange.eventStart.toISOString(),
            totalTimeRange.eventEnd.toISOString(),
            spaceId,
        ].join('|');
    }, [totalTimeRange, spaceId]);
    // Track the latest rendered key so cleanup can avoid aborting same-key in-flight requests
    latestConflictKeyRef.current = conflictCheckKey;
    useEffect(function () {
        var _a;
        if (!totalTimeRange || conflictCheckKey === previousCheckKeyRef.current) {
            return;
        }
        // Don't abort and restart if this key is already being fetched
        if (conflictCheckKey === inFlightKeyRef.current) {
            return;
        }
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        (_a = conflictAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        var controller = new AbortController();
        conflictAbortControllerRef.current = controller;
        debounceRef.current = setTimeout(function () {
            inFlightKeyRef.current = conflictCheckKey;
            incrementConflictChecks();
            checkSpaceHasConflict(spaceId, totalTimeRange.totalStart, totalTimeRange.totalEnd, controller.signal)
                .then(function (allConflicts) {
                var e_1, _a;
                if (controller.signal.aborted)
                    return;
                var hasEventTimeConflict = false;
                var hasBufferConflict = { before: false, after: false };
                if (allConflicts && allConflicts.length > 0) {
                    try {
                        for (var allConflicts_1 = __values(allConflicts), allConflicts_1_1 = allConflicts_1.next(); !allConflicts_1_1.done; allConflicts_1_1 = allConflicts_1.next()) {
                            var conflict = allConflicts_1_1.value;
                            var conflictStart = moment(conflict.eventStartTime);
                            var conflictEnd = moment(conflict.eventEndTime);
                            var overlapsEventTime = conflictStart.isBefore(totalTimeRange.eventEnd) &&
                                conflictEnd.isAfter(totalTimeRange.eventStart);
                            var hasBeforeBuffer = totalTimeRange.totalStart.isBefore(totalTimeRange.eventStart);
                            var hasAfterBuffer = totalTimeRange.totalEnd.isAfter(totalTimeRange.eventEnd);
                            var overlapsBeforeBuffer = hasBeforeBuffer &&
                                conflictStart.isBefore(totalTimeRange.eventStart) &&
                                conflictEnd.isAfter(totalTimeRange.totalStart);
                            var overlapsAfterBuffer = hasAfterBuffer &&
                                conflictStart.isBefore(totalTimeRange.totalEnd) &&
                                conflictEnd.isAfter(totalTimeRange.eventEnd);
                            if (overlapsEventTime) {
                                hasEventTimeConflict = true;
                            }
                            if (overlapsBeforeBuffer) {
                                hasBufferConflict.before = true;
                            }
                            if (overlapsAfterBuffer) {
                                hasBufferConflict.after = true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (allConflicts_1_1 && !allConflicts_1_1.done && (_a = allConflicts_1.return)) _a.call(allConflicts_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                updateSpaceConflicts(spaceId, {
                    spaceBuffers: hasBufferConflict,
                    eventTime: hasEventTimeConflict,
                });
            })
                .catch(function (error) {
                if (error.name !== 'AbortError') {
                    onError(new Error('Error checking event conflicts: ' + error.message));
                }
            })
                .finally(function () {
                inFlightKeyRef.current = undefined;
                decrementConflictChecks();
                previousCheckKeyRef.current = conflictCheckKey;
            });
        }, 300);
        // Only abort if the key genuinely changed — not just a reference-unstable re-render
        return function () {
            var _a;
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            if (latestConflictKeyRef.current !== inFlightKeyRef.current) {
                (_a = conflictAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
            }
        };
    }, [
        checkSpaceHasConflict,
        conflictCheckKey,
        totalTimeRange,
        updateSpaceConflicts,
        incrementConflictChecks,
        decrementConflictChecks,
        onError,
        spaceId,
    ]);
};
